 <style>
  .serviceRow div:first-of-type {padding-left:0px;} 
 </style>
 
<div class="row" style="margin-bottom:5px">
 
    <div class="col-sm-8"> 
      <label>{{title}}</label>
    </div> 
    
    <div class="col-sm-4 text-right">
        <button class="btn btn-sm btn-outline-secondary" (click)="isAddingNewService=true">
            <i class="fa fa-plus mr-5"></i>Assign Service
        </button>
    </div>

</div>

<div *ngFor="let id of serviceIds" class="gridRow row serviceRow">

  <div class="col-sm-11">
    <app-calendar-item-edit-related-services-individual [serviceId]="id"></app-calendar-item-edit-related-services-individual>
  </div> 

  <div class="col-sm-1">
    <div class="btn-group"> 
      <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Delete" (click)="delete(id)">
          <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
  
</div>

<div *ngIf="isAddingNewService">
  <input type="text" style="width:300px" [(ngModel)]="newServiceId">
  <button class="btn btn-sm btn-outline-secondary" (click)="addService()">Add</button>
</div> 